module.exports = __webpack_public_path__ + "static/media/fao_1.c73403ba.png";